<script setup>
import { defineProps } from 'vue'
import { useMainStore } from '@/stores/main'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import ApiEndpointSlideOver from '@/components/Docs/ApiEndpointSlideOver.vue'

const mainStore = useMainStore()

const props = defineProps({
  title: String,        // Endpoint path (e.g., "/query/ip/:ip")
  method: String,       // HTTP method: "GET" or "POST"
  name: String,         // Endpoint name for slideover (e.g., "IP Information")
  query: String,        // Dynamic query URL (computed from parameters)
  body: Object,         // Request body (optional, for POST only)
  download: {           // File-download endpoint (stream, not JSON)
    type: Boolean,
    default: false
  }
})

function runRequest() {
  mainStore.show_slideover(
    ApiEndpointSlideOver,
    { query: props.query, name: props.name, method: props.method, body: props.body, download: props.download },
    { width: 50 },
    props.name
  )
}
</script>

<template>
  <div class="block mb-3">
    <div class="title">
      <div class="title-content">
        <span v-if="method === 'GET'" class="method" style="color: var(--color-success-text);">{{ method }}</span>
        <span v-if="method === 'POST'" class="method" style="color: var(--color-info-text);">{{ method }}</span>
        <span class="endpoint-title">{{ props.title }}</span>
      </div>
      <button class="play-button" @click="runRequest" title="Run request">
        <font-awesome-icon :icon="['fas', 'play']" />
      </button>
    </div>
    <div v-if="props.body && method === 'POST'" class="content">
      <vue-json-pretty :data="props.body" style="overflow: auto; max-height: 600px;"/>
    </div>
  </div>
</template>

<style scoped>
.block {
  border-radius: var(--radius-lg);
  background-color: var(--surface-sunken);
  overflow: hidden;
}

.method {
  font-weight: 600;
  font-size: .8rem;
  margin-right: .5rem;
}

.block .title {
  padding: .6rem .9rem;
  color: var(--text-heading);
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-content {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.endpoint-title {
  color: var(--text-primary);
  font-family: var(--font-heading);
  font-size: 0.85rem;
  word-break: break-all;
}

.block :deep(.vjs-tree) {
  font-family: var(--font-heading);
}

.play-button {
  background-color: var(--color-info);
  color: var(--text-heading);
  border: none;
  border-radius: var(--radius-sm);
  padding: 0.35rem 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  margin-left: 1rem;
}

.play-button:hover {
  background-color: var(--color-info);
}

.play-button svg {
  width: 10px;
  height: 10px;
}

.block .content {
  padding: .9rem;
  overflow: auto;
  border-top: 1px solid var(--border-subtle);
}

::-webkit-scrollbar-thumb {
  background-color: var(--border);
  border-radius: var(--radius-xl);
  border: 6px solid transparent;
  background-clip: content-box;
}
</style>
